import {
  ChangeDetectionStrategy,
  Component,
  HostBinding
} from '@angular/core';
import { StickyObserverComponent } from '../observer/sticky-observer.component';

@Component({
  selector: 'td-wb-sticky-panel-bottom',
  templateUrl: 'sticky-panel-bottom.component.html',
  styleUrls: ['sticky-panel-bottom.component.scss'],
  imports: [
    StickyObserverComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class StickyPanelBottomComponent {
  @HostBinding('class.td-wb-sticky-panel-bottom--sticky') sticky: boolean;

  stickyStateChange(state: boolean): void {
    this.sticky = state;
  }
}
